import React from "react";
import { Plugins } from '@capacitor/core';

const { Storage } = Plugins;

const token:string ="";
const tokenType:string ="";

 export const setItem = async(key:string,val:string)=> {
   await Storage.set({
     key: key,
     value:  JSON.stringify(val)
   });
 }
 
export  const getItem= async(key:string)=> {
   const { value } = await Storage.get({ key: 
   key });
   console.log('Got item: ', value);
 }